import React, { useContext } from "react"
import { useTranslation } from "react-i18next";
import { useKeycloak } from "@react-keycloak/web";
import { UserContext } from "../context/UserContext"
import { NavLink } from "react-router-dom";
import logo from "../assets/img/brand/jobbit-logo-bel.svg"
import MeetingRoomTwoToneIcon from '@mui/icons-material/MeetingRoomTwoTone';
import { IconButton, Tooltip } from "@mui/material";
import LanguageSelector from "../widget/LanguageSelector";

const TopBar = () => {
  const { user } = useContext(UserContext);

  const { t } = useTranslation();
  const keycloakInstance = useKeycloak();

  function onLogOutButton() {
    keycloakInstance.keycloak.logout();
  }

  return (
    <nav className="navbar is-fixed-top" style={{display: 'flex', flexDirection: 'row', alignItems: 'center',justifyContent: 'space-between'}}>
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <NavLink to="/" className="" style={{ height: '50px', margin: '5px', marginLeft: '20px' }}>
          <img src={logo} alt="PsyBit" height={'46px'} width={'123px'} />
        </NavLink>
      </div>
      <div className="has-margin-right-20" style={{display: 'flex', flexDirection: 'column'}}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <LanguageSelector />
          <div >
            {t("welcome") + ", " + user.firstName}!
          </div>
          <Tooltip title={t('logout')}>
            <IconButton className="has-padding-right-10" onClick={onLogOutButton}>
              <MeetingRoomTwoToneIcon className="color color-white" />
            </IconButton>
          </Tooltip>
          </div>
      </div>
    </nav>

  )
}

export default TopBar;
